import PropTypes from "prop-types";
import "./PopoverInfo.scss";
import FloatingButton from "app/pages/.shared/Popover/FloatingButton";
import { InfoCircleStrokeIcon } from "app/icons/navigation";
import { ICON_SIZES } from "app/constants";

const PopoverInfo = ({
	popOverContent,
	popOverClassName = "",
	popOverContainerClassName = "",
	popOverButtonClassName = "",
	popOverContentClassname = "",
}) => {
	return (
		<FloatingButton
			popoverClassName={`popover-info ${popOverClassName ?? ""}`}
			floatingContainerClassName={`popover-info__container ${popOverContainerClassName ??
				""}`}
			referenceButtonClassName={`popover-info__button  ${popOverButtonClassName ?? ""}`}
			position="bottom"
			floatingContent={
				// eslint-disable-next-line local-rules/no-dynamic-classname
				<div className={`popover-info__content ${popOverContentClassname}`}>
					{popOverContent}
				</div>
			}
			referenceComponent={
				<InfoCircleStrokeIcon size={ICON_SIZES.XXS} style={{ marginLeft: "5px" }} />
			}
			zIndexValue={10}
		/>
	);
};

PopoverInfo.propTypes = {
	popOverContent: PropTypes.object,
	popOverClassName: PropTypes.string,
	popOverContainerClassName: PropTypes.string,
	popOverButtonClassName: PropTypes.string,
	popOverContentClassname: PropTypes.string,
};

export default PopoverInfo;
